import axios from "@/plugins/axios.js"
import api from "@/api.js"
export default new class FaceService{
	constructor(){
		this.listFaces = [];
	}
	getFaces(){
		return this.listFaces;
	}
	async getList(pg=1, params={}){
		try{
			if (api) {				
				const uri = `${api.url}/api/v1/face/trained/`;// ?page=${pg}					
				const data = await axios.get(uri, { params :{page: pg, ...params }});							
				return data;
			}
		}catch(er){
			console.warn("Error get FaceService ", er)
			return er;
		}
		return null;
	}
	async getListFor(pg=1){		
		try{
			let isloadingReq = true; 
			while(isloadingReq){
				const res =  await this.getList(pg);
				if (res && res.data && res.data.rows.length > 0) {						
					this.listFaces 		= this.listFaces.concat(res.data.rows);// temp_list;					
				}			
				// console.log("valid list ", parseInt(res.data.pages) > pg, parseInt(res.data.pages) , " > ", pg)		
				if (parseInt(res.data.pages) > pg) {
					pg++;				
				}else{
					isloadingReq=false
					// console.log("return list ", this.listFaces)
					return this.listFaces;
				}
			}
			
		}catch(er){
			console.warn("Error get FaceService For ", er)
			return er;
		}
		
	}
}